import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/livekit/select';

const languageNames = {
  ja: '日本語',
  en: 'English',
};

const supportedLocales = ['ja', 'en'] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageChange = (newLocale: string) => {
    i18n.changeLanguage(newLocale);

    // Update URL: /ja/... → /en/... (or vice versa)
    const pathSegments = location.pathname.split('/').filter(Boolean);
    if (supportedLocales.includes(pathSegments[0] as any)) {
      pathSegments[0] = newLocale;
    }
    navigate('/' + pathSegments.join('/') + location.search);
  };

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-32">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {supportedLocales.map((loc) => (
          <SelectItem key={loc} value={loc}>
            {languageNames[loc]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
